// Generated by Melange

import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Curry from "melange.js/curry.js";
import * as Js__Js_dict from "melange.js/js_dict.js";
import * as Mapre_web__Browser from "./browser.js";
import * as Mapre_web__Web_codec from "./web_codec.js";
import * as Mapre_web__Web_model from "./web_model.js";
import * as Mapre_web__Web_permissions_model from "./web_permissions_model.js";
import * as Mapre_web__Web_types from "./web_types.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";
import * as Stdlib__Array from "melange/array.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";

function cancel(t) {
  t.generation = t.generation + 1 | 0;
  t.revision = t.revision + 1 | 0;
  Mapre_web__Browser.abort(t.controller);
  t.controller = new AbortController();
  t.loading = false;
  t.dirty = false;
}

function path(t) {
  const match = Curry._1(t.model, undefined).route;
  if (/* tag */ typeof match !== "object" && typeof match !== "function" || !(match.TAG === /* Session */ 3 && !Mapre_web__Web_model.locked(Curry._1(t.model, undefined)))) {
    return;
  } else {
    return "/api/workspaces/" + (match._0 + ("/sessions/" + (match._2 + "/permissions")));
  }
}

function active(t, generation) {
  if (generation === t.generation) {
    return path(t) !== undefined;
  } else {
    return false;
  }
}

function refresh(t) {
  const path$1 = path(t);
  if (path$1 === undefined) {
    return;
  }
  if (t.loading) {
    t.dirty = true;
    return;
  }
  t.loading = true;
  t.dirty = false;
  const generation = t.generation;
  const revision = t.revision;
  Mapre_web__Browser.request(t.controller, undefined, undefined, path$1).then(function (result) {
    if (active(t, generation)) {
      t.loading = false;
      if (revision !== t.revision) {
        t.dirty = true;
      } else if (result.TAG === /* Ok */ 0) {
        try {
          const action = {
            TAG: /* Loaded */ 2,
            _0: Stdlib__Array.to_list(Stdlib__Array.map(Mapre_web__Web_permissions_model.decode, Mapre_wire__Json.array(result._0, "permissions")))
          };
          Curry._1(t.emit, {
            TAG: /* Permissions */ 42,
            _0: action
          });
        }
        catch (raw_exn){
          const exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
          if (exn.MEL_EXN_ID === Mapre_wire__Json.Invalid) {
            Curry._1(t.emit, {
              TAG: /* Permissions */ 42,
              _0: {
                TAG: /* Message */ 6,
                _0: "Invalid permission response."
              }
            });
          } else {
            throw exn;
          }
        }
      } else {
        const error = result._0;
        if (/* tag */ typeof error !== "object" && typeof error !== "function") {
          if (error === /* Unauthorized */ 0) {
            Curry._1(t.failure, error);
          } else {
            Curry._1(t.emit, {
              TAG: /* Permissions */ 42,
              _0: {
                TAG: /* Message */ 6,
                _0: "Unable to refresh permissions. Retry when online."
              }
            });
          }
        } else if (error.TAG === /* Missing */ 0) {
          Curry._1(t.failure, error);
        } else {
          Curry._1(t.emit, {
            TAG: /* Permissions */ 42,
            _0: {
              TAG: /* Message */ 6,
              _0: "Unable to refresh permissions. Retry when online."
            }
          });
        }
      }
      if (t.dirty) {
        refresh(t);
      }
      
    }
    return Promise.resolve();
  });
}

function reply_error(t, seq, error) {
  if (/* tag */ typeof error !== "object" && typeof error !== "function") {
    switch (error) {
      case /* Unauthorized */ 0 :
        return Curry._1(t.failure, error);
      case /* Forbidden */ 1 :
        return Curry._1(t.emit, {
          TAG: /* Permissions */ 42,
          _0: /* Denied */ 3
        });
      case /* Invalid_response */ 2 :
        break;
    }
  } else {
    if (error.TAG === /* Missing */ 0) {
      return Curry._1(t.failure, error);
    }
    let exit = 0;
    switch (error._0) {
      case "permission_already_answered" :
      case "run_not_active" :
      case "version_conflict" :
        exit = 2;
        break;
    }
    if (exit === 2) {
      Curry._1(t.emit, {
        TAG: /* Permissions */ 42,
        _0: {
          TAG: /* Failed */ 5,
          _0: seq,
          _1: "Another decision or run update was accepted. Review the current request."
        }
      });
      return refresh(t);
    }
    
  }
  Curry._1(t.emit, {
    TAG: /* Permissions */ 42,
    _0: {
      TAG: /* Phase */ 4,
      _0: seq,
      _1: /* Uncertain */ 1
    }
  });
  refresh(t);
}

function send(t, attempt) {
  const path$1 = path(t);
  if (path$1 === undefined) {
    return;
  }
  t.revision = t.revision + 1 | 0;
  Curry._1(t.emit, {
    TAG: /* Permissions */ 42,
    _0: {
      TAG: /* Started */ 3,
      _0: {
        seq: attempt.seq,
        command_id: attempt.command_id,
        expected_version: attempt.expected_version,
        option_id: attempt.option_id,
        phase: /* Sending */ 0
      }
    }
  });
  const generation = t.generation;
  const body = JSON.stringify(Js__Js_dict.fromList({
    hd: [
      "command_id",
      Mapre_wire__Json.str(attempt.command_id)
    ],
    tl: {
      hd: [
        "expected_version",
        attempt.expected_version
      ],
      tl: {
        hd: [
          "option_id",
          Stdlib__Option.fold(null, Mapre_wire__Json.str, attempt.option_id)
        ],
        tl: /* [] */ 0
      }
    }
  }));
  Mapre_web__Browser.request(t.controller, undefined, body, path$1 + ("/" + (String(attempt.seq) + "/reply"))).then(function (result) {
    if (active(t, generation)) {
      t.revision = t.revision + 1 | 0;
      if (result.TAG === /* Ok */ 0) {
        if (Mapre_web__Web_codec.text(result._0, "command_id") !== attempt.command_id) {
          reply_error(t, attempt.seq, /* Invalid_response */ 2);
        } else {
          Curry._1(t.emit, {
            TAG: /* Permissions */ 42,
            _0: {
              TAG: /* Phase */ 4,
              _0: attempt.seq,
              _1: /* Accepted */ 2
            }
          });
          refresh(t);
        }
      } else {
        reply_error(t, attempt.seq, result._0);
      }
    }
    return Promise.resolve();
  });
}

function choose(t, confirmed, seq, option_id) {
  const model = Curry._1(t.model, undefined);
  const item = Mapre_web__Web_permissions_model.find(model.permissions, seq);
  if (item === undefined) {
    return;
  }
  if (!(Mapre_web__Web_model.can_create(model) && !Mapre_web__Web_model.locked(model) && !model.permissions.denied && Caml_obj.caml_equal(item.decision, /* Pending */ 0) && Mapre_web__Web_permissions_model.attempt(model.permissions, seq) === undefined)) {
    return;
  }
  const choice = Stdlib__Option.bind(option_id, (function (id) {
    return Stdlib__List.find_opt((function (c) {
      return c.id === id;
    }), item.options);
  }));
  if (option_id !== undefined && choice === undefined) {
    return;
  }
  if (!(!confirmed && Stdlib__Option.fold(false, Mapre_web__Web_permissions_model.persistent, choice))) {
    return send(t, {
      seq,
      command_id: crypto.randomUUID(),
      expected_version: item.version,
      option_id,
      phase: /* Sending */ 0
    });
  }
  const action_1 = Stdlib__Option.get(option_id);
  const action = {
    TAG: /* Confirming */ 7,
    _0: seq,
    _1: action_1
  };
  Curry._1(t.emit, {
    TAG: /* Permissions */ 42,
    _0: action
  });
}

function dispatch(t, seq) {
  if (/* tag */ typeof seq !== "object" && typeof seq !== "function") {
    switch (seq) {
      case /* Confirm */ 0 :
        return Stdlib__Option.iter((function (param) {
          choose(t, true, param[0], param[1]);
        }), Curry._1(t.model, undefined).permissions.confirmation);
      case /* Keep_reviewing */ 1 :
        return Curry._1(t.emit, {
          TAG: /* Permissions */ 42,
          _0: /* Keep_reviewing */ 1
        });
      case /* Refresh */ 2 :
        const generation = t.generation;
        if (path(t) !== undefined) {
          Mapre_web__Browser.request(t.controller, undefined, undefined, "/api/workspaces").then(function (result) {
            if (active(t, generation)) {
              if (result.TAG === /* Ok */ 0) {
                try {
                  const workspaces = Mapre_web__Web_codec.workspaces(result._0);
                  if (Stdlib__List.exists((function (w) {
                      return Caml_obj.caml_equal(w.id, Mapre_web__Web_types.workspace(Curry._1(t.model, undefined).route));
                    }), workspaces)) {
                    Curry._1(t.emit, {
                      TAG: /* Workspaces */ 1,
                      _0: workspaces
                    });
                    Curry._1(t.emit, {
                      TAG: /* Permissions */ 42,
                      _0: /* Access_refreshed */ 4
                    });
                    refresh(t);
                  } else {
                    Curry._1(t.failure, {
                      TAG: /* Missing */ 0,
                      _0: "workspace_not_found"
                    });
                  }
                }
                catch (raw_exn){
                  const exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
                  if (exn.MEL_EXN_ID === Mapre_wire__Json.Invalid) {
                    Curry._1(t.emit, {
                      TAG: /* Permissions */ 42,
                      _0: {
                        TAG: /* Message */ 6,
                        _0: "Invalid access response."
                      }
                    });
                  } else {
                    throw exn;
                  }
                }
              } else {
                Curry._1(t.failure, result._0);
              }
            }
            return Promise.resolve();
          });
          return;
        } else {
          return;
        }
      default:
        return;
    }
  } else {
    switch (seq.TAG) {
      case /* Choose */ 0 :
        return choose(t, false, seq._0, seq._1);
      case /* Retry */ 1 :
        const model = Curry._1(t.model, undefined);
        if (Mapre_web__Web_model.can_create(model) && !Mapre_web__Web_model.locked(model) && !model.permissions.denied) {
          return Stdlib__Option.iter((function (a) {
            if (a.phase === /* Uncertain */ 1) {
              return send(t, a);
            }
            
          }), Mapre_web__Web_permissions_model.attempt(model.permissions, seq._0));
        } else {
          return;
        }
      default:
        return;
    }
  }
}

function create(emit, model, failure) {
  return {
    emit,
    model,
    failure,
    generation: 0,
    revision: 0,
    controller: new AbortController(),
    loading: false,
    dirty: false
  };
}

export {
  create,
  cancel,
  refresh,
  dispatch,
}
/* Mapre_web__Browser Not a pure module */
